import {LoginServices} from "../../views/Pages/Login/LoginServices";
import {AdminBaseListServices} from "../../containers/AdminLayout/AdminServices";
import {AdminDashboardDataServices} from "../../views/AdminServices/AdminDashboard/AdminDashboardServices";
import {AdminClientListServices, AdminAddClientServices, AdminDeleteClientServices} from "../../views/AdminServices/ClientList/ClientListServices";
import {AdminGCListServices, AdminGCMeterServices, AdminAddGCServices, AdminEditGCServices, AdminDeleteGCServices} from "../../views/AdminServices/GCList/GCListServices";
import {AdminClientDetailServices, AdminUpdateClientGCServices, AdminAddClientMeterServices, AdminEditClientMeterServices, AdminEditClientServices, AdminChangeClientPasswordServices, AdminDeleteMeterServices} from "../../views/AdminServices/EditClient/EditClientServices";
import {AdminBaseEditFlowValueServices} from "../../views/AdminServices/BaseList/BaseListServices";
import {AdminClientDataViewServices, } from "../../views/AdminServices/ViewClient/ViewClientServices";
import {MmscmFileUploadServices, BannerServices,} from "../../views/AdminServices/MmscmUpload/MmscmUploadServices";
import {ClientDataViewServices, } from "../../views/ClientServices/ViewClient/ViewClientServices";
import {ClientChangePasswordServices } from "../../views/ClientServices/ChangePassword/ChangePasswordServices";
import {AdminBaseUserListServices, AdminAddBaseUserServices, AdminEditBaseUserServices, AdminDeleteBaseUserServices} from "../../views/AdminServices/BaseUsers/BaseUsersServices";
import {AdminGCDataViewServices} from "../../views/AdminServices/ViewGC/ViewGCServices";
import {BaseChangePasswordServices} from "../../views/BaseServices/ChangePassword/ChangePasswordServices"
class RemoteCall {
  static Authenticate() {
    return LoginServices;
  }

  static AdminDashboard(){
    return AdminDashboardDataServices;
  }
  static AdminBaseList() {
    return AdminBaseListServices;
  }
  static AdminClientList() {
    return AdminClientListServices;
  }

  static AdminBaseFlowValue() {
    return AdminBaseEditFlowValueServices;
  }

  static MmscmFileUpload() {
    return MmscmFileUploadServices;
  }
  static BannerServices() {
      return BannerServices;
    }




  static AdminAddClient() {
    return AdminAddClientServices;
  }

  static AdminDeleteClient() {
    return AdminDeleteClientServices;
  }

  static AdminEditClient() {
    return AdminEditClientServices;
  }

  static AdminChangeClientPassword() {
    return AdminChangeClientPasswordServices;
  }
  static AdminDeleteMeter() {
    return AdminDeleteMeterServices;
  }

  static AdminClientDetail() {
    return AdminClientDetailServices;
  }

  static UpdateClientGC() {
    return AdminUpdateClientGCServices;
  }

  static AdminAddClientMeter() {
    return AdminAddClientMeterServices;
  }
  static AdminEditClientMeter() {
      return AdminEditClientMeterServices;
  }
  static AdminClientDataView() {
      return AdminClientDataViewServices;
  }

  static AdminGCList() {
      return AdminGCListServices;
  }
  static AdminGCMeter() {
        return AdminGCMeterServices;
    }

  static AdminAddGC() {
      return AdminAddGCServices;
  }
  static AdminEditGC() {
        return AdminEditGCServices;
    }

  static AdminDeleteGC() {
      return AdminDeleteGCServices;
  }

  static ClientDataView() {
      return ClientDataViewServices;
  }

  static AdminBaseUserList(){
    return AdminBaseUserListServices;
  }
  static AdminAddBaseUser(){
    return AdminAddBaseUserServices;
  }
  static AdminEditBaseUser(){
    return AdminEditBaseUserServices;
  }
  static AdminDeleteBaseUser(){
    return AdminDeleteBaseUserServices;
  }

  static AdminGCDataView(){
    return AdminGCDataViewServices;
  }

  static ClientChangePassword(){
    return ClientChangePasswordServices;
  }
  static BaseChangePassword(){
    return BaseChangePasswordServices;
  }


}

export {RemoteCall};
